import styled from 'styled-components';

export const HorizontalDivider = styled.hr`
  margin: 0px;
  padding: 0px;
`;

export const VerticalDivider = styled.div`
  border-left: 1px solid black;
  min-height: 100%;
`;
